import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';

import { handleError } from 'services/Error';
import { useExcludeOutboundFileScriptMutation } from 'store/api/ndpApi';

const Title = 'Remove Prescription';

export const RemoveOutboundFileScriptDialog = ({
    isOpen,
    rxNumber = undefined,
    outboundFileId = undefined,
    onClose,
    onRemoved = undefined,
}) => {
    const [excludeOutboundFileScript] = useExcludeOutboundFileScriptMutation();

    return (
        <WarningDialog
            isOpen={isOpen}
            dialogTitle={Title}
            onSecondaryButtonClick={() => {
                onClose();
            }}
            onPrimaryButtonClick={async () => {
                if (!rxNumber || !outboundFileId) {
                    return;
                }
                try {
                    await excludeOutboundFileScript({
                        rxNumber,
                        outboundFileId,
                    }).unwrap();
                    SuccessToast({
                        message: 'Prescription removed from the outbound file.',
                    });
                    onRemoved?.(rxNumber);
                    onClose();
                } catch (error) {
                    handleError(
                        'Unable to remove the prescription from the outbound file. Please try again.',
                        error,
                    );
                }
            }}
            primaryButtonLabel="Yes, Remove Prescription"
            primaryButtonIntent={Button.Intent.DANGER}
            secondaryButtonLabel="Cancel"
            dialogContent={
                <div className="padding__bottom--medium">
                    Are you sure you want to remove this prescription from the outbound file?
                </div>
            }
        />
    );
};

RemoveOutboundFileScriptDialog.Title = Title;

RemoveOutboundFileScriptDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    rxNumber: PropTypes.string,
    outboundFileId: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onRemoved: PropTypes.func,
};
